var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountLarge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EEF0F3",
    cx: 32,
    cy: 27.539,
    r: 13.873
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#848992",
    strokeWidth: 1.2,
    cx: 32,
    cy: 27.539,
    r: 13.273
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#848992",
    strokeWidth: 1.2,
    cx: 32,
    cy: 32,
    r: 31.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.393 57.108c2.65-16.87 28.273-26.053 37.222 0",
    stroke: "#848992",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLarge);
export default __webpack_public_path__ + "static/media/accountLarge.4a4ae57c57ff6336559ae5617a8732b2.svg";
export { ForwardRef as ReactComponent };